import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

export default function SearchAppBar() {
  return (
    <Box>
      <AppBar position="fixed" component="nav">
        <Toolbar variant="dense">
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
            }}
          >
            My-sales
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
